import { html } from "lit";
import { formatHtml } from "@trumpf/ux.common-storybook";
import { renderPageTemplate } from "../../../utils";

export default {
    title: "Shop/Page Templates/Starter",
    parameters: {
        docs: {
            source: {
                transform: formatHtml,
            },
        },
    },
};

const Template = () => {
    return html``;
};

export const Default = () => renderPageTemplate(() => Template());
